import React, { memo } from 'react';
import { Handle, Position } from 'reactflow';
import '../CustomNode/CustomNode.css';


function CustomLoopNode({id, data}:any) {
    const customNodeClass = (data.access_type === 'ALL' ? 'custom-node__body_loop_red' : 'custom-node__body_loop');
    if(data.access_type === 'ALL'){
      data = 'Full Table Scan'
    }else{
      data = id;
    }
  return (
    <>
      
      <div className={customNodeClass}>
      <Handle
        type="source"
        position={Position.Bottom}
        id="Bottom"
      />
        <pre style={{textAlign: 'center'}}>{data}</pre>
        <Handle
        type="target"
        position={Position.Top}
        id="Top"
      />
      <Handle
        type="source"
        position={Position.Right}
        id="Right"
      />
      <Handle
        type="target"
        position={Position.Left}
        id="Left"
      />
      </div>
    </>
  );
}

export default memo(CustomLoopNode);
